export default __webpack_public_path__ + "static/media/Scepter of the August Ones.58963194.jpg";